// extracted by mini-css-extract-plugin
export default {"component":"l0T21c","dashed":"SU1o38","table-conatiner":"LRXYK5","hidden":"eleUv6"};